import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function Newsletter() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const MAILERLITE_TOKEN = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI0IiwianRpIjoiOWJjMzE0ZTVkZGIxODc0ZjJmMjEzNjFhYWZjM2JjZDc3MjNmOTE2NTUwZTUwN2Y4MWU0MzdhNjE4NjM5OGFlMDk4ZmI4YWVmYmM0ZjFlYWIiLCJpYXQiOjE3NTc1MjQwNzQuMTc0NzA1LCJuYmYiOjE3NTc1MjQwNzQuMTc0NzA3LCJleHAiOjQ5MTMxOTc2NzQuMTcwNjU5LCJzdWIiOiIxNzkzNDI2Iiwic2NvcGVzIjpbXX0.iu4NI1pp5zIzF4qQ_wXpLB9gHHIucgQi7hncwEAqODrXHzJAiSr4bO-mdOXauwgorxASJMZz6gT04U_WBj54bpsbtiIw8UWdral76eDQVLyS3hy5Du83EMV8tmHibTbXMURVYCSvE5kAT9tUp8tGeeu19qhkpjpGlFJvISdeExmMd6SDnN0UWVBdXCfNfM4Nr0Jax2gr-zeaL3XJmNybMDqbTTiR9XI2t3hGPmjL02mjrhJ-nTs7fbOUIsLenJcxZz6P9WxzAFZ2IIP4a_uCUrvaQkPFjOmTpdXyzS_mz7uJov08S8Z8TCoQg2hx846gMlB7o60xdT0bRyouK-E_44VKJojS4C6lJkAOSOTaDqkaJj7Z_KZudLlyLVHzPyex7Jo9pOPNJPGhkoQh_99HevUUQYiA1TTvGqLUtDooP0H9wbcY69C42FNtlFX2PXsawrvBFGvUNbWfK3a_v0-jVA1mLxvmS8h4V5mcfSSsyVvevvtp9clxWsRpOjJmjdEE8ueuQ4JlISs2kPMH0Xu28KO0mebHR0NpymTfH3pNvMOp7YOzV4jikk9ZDg8R1wLt_l7oba1opz88oxbHOB6O9dlxeF_J8yPpbhxTbTHi0MinKNu9Xwq3dm0vrP7PmGOuyEmYIou2Zdh0tr4Bjof6DirZhwB5ufM7Cmg1Q3rtkjs';
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setIsLoading(true);
    setError('');
    setSuccess(false);
    try {
      const response = await fetch('https://connect.mailerlite.com/api/subscribers', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${MAILERLITE_TOKEN}`
        },
        body: JSON.stringify({
          email: email,
          fields: {
            name: ''
          },
          groups: [],
          status: 'active'
        })
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Failed to subscribe. Please try again.');
      }
      setSuccess(true);
      setEmail('');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Something went wrong. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };
  return <section id="newsletter" className="py-28 px-6 md:px-12 relative overflow-hidden" style={{
    backgroundColor: '#F4F6ED'
  }} data-id="element-195">
      {/* Decorative elements */}
      <div className="absolute top-1/3 left-0 w-24 h-px bg-ink-300 opacity-30" data-id="element-196"></div>
      <div className="absolute top-2/3 right-0 w-24 h-px bg-ink-300 opacity-30" data-id="element-197"></div>
      <div className="absolute top-20 right-20 w-16 h-16 border border-dashed border-ink-300 rounded-full opacity-30" data-id="element-198"></div>
      <div className="absolute bottom-20 left-20 w-12 h-12 border border-dotted border-ink-300 rounded-full opacity-30" data-id="element-199"></div>
      <div className="container mx-auto max-w-5xl" data-id="element-200">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-201">
          <div className="grid md:grid-cols-2 gap-20 items-center" data-id="element-202">
            <div data-id="element-203">
              <div className="relative inline-block" data-id="element-204">
                <h2 className="text-3xl font-currency italic tracking-wide mb-5 currency-heading" data-id="element-205">
                  Quick 3 Product Moves
                </h2>
                <div className="absolute -right-8 top-1/2 transform -translate-y-1/2 w-6 h-px bg-ink-900" data-id="element-206"></div>
                <div className="absolute -left-8 top-1/2 transform -translate-y-1/2 w-6 h-px bg-ink-900" data-id="element-207"></div>
              </div>
              <div className="h-px w-16 bg-ink-900 mb-10" data-id="element-208"></div>
              <p className="text-ink-600 mb-10 font-serif" data-id="element-209">
                Subscribe to my weekly newsletter where I share three actionable
                ideas to improve your product strategy, execution, and
                leadership.
              </p>
              <ul className="space-y-5 mb-8" data-id="element-210">
                <li className="flex items-center" data-id="element-211">
                  <div className="w-1.5 h-1.5 rounded-full bg-ink-900 mr-3" data-id="element-212"></div>
                  <span className="text-ink-700 font-serif" data-id="element-213">
                    Concise and actionable
                  </span>
                </li>
                <li className="flex items-center" data-id="element-214">
                  <div className="w-1.5 h-1.5 rounded-full bg-ink-900 mr-3" data-id="element-215"></div>
                  <span className="text-ink-700 font-serif" data-id="element-216">
                    Real-world examples
                  </span>
                </li>
                <li className="flex items-center" data-id="element-217">
                  <div className="w-1.5 h-1.5 rounded-full bg-ink-900 mr-3" data-id="element-218"></div>
                  <span className="text-ink-700 font-serif" data-id="element-219">
                    No fluff, just value
                  </span>
                </li>
              </ul>
            </div>
            <div data-id="element-220">
              <form onSubmit={handleSubmit} className="bg-white border border-ink-100 p-10 relative" data-id="element-221">
                {/* Added decorative corner lines */}
                <div className="absolute top-0 left-0 w-5 h-5 border-t border-l border-ink-200" data-id="element-222"></div>
                <div className="absolute top-0 right-0 w-5 h-5 border-t border-r border-ink-200" data-id="element-223"></div>
                <div className="absolute bottom-0 left-0 w-5 h-5 border-b border-l border-ink-200" data-id="element-224"></div>
                <div className="absolute bottom-0 right-0 w-5 h-5 border-b border-r border-ink-200" data-id="element-225"></div>
                {success ? <div className="text-center py-8" data-id="element-226">
                    <div className="text-racing-500 mb-4" data-id="element-227">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-228">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-229" />
                      </svg>
                    </div>
                    <h3 className="text-xl font-currency tracking-wide mb-3" data-id="element-230">
                      Thank you for subscribing!
                    </h3>
                    <p className="text-ink-600 font-serif" data-id="element-231">
                      You'll receive your first issue soon.
                    </p>
                  </div> : <>
                    <div className="mb-8" data-id="element-232">
                      <label htmlFor="email" className="block text-ink-700 mb-3 text-sm font-medium font-currency tracking-wide" data-id="element-233">
                        Email address
                      </label>
                      <input type="email" id="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full px-4 py-3 border border-ink-300 focus:outline-none focus:ring-1 focus:ring-ink-900 focus:border-ink-900 font-serif" placeholder="youremail@example.com" required disabled={isLoading} data-id="element-234" />
                      {error && <p className="mt-2 text-red-600 text-sm font-serif" data-id="element-235">
                          {error}
                        </p>}
                    </div>
                    <Button className="w-full" disabled={isLoading} data-id="element-236">
                      {isLoading ? 'Subscribing...' : 'Subscribe to newsletter'}
                    </Button>
                  </>}
              </form>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}